export default "__VITE_ASSET__D8duW90$__"